import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NotFound from "./pages/NotFound.tsx";
import "./index.css";
import Experience from "./pages/experience/Experience.tsx";
import Intro from "./pages/Intro.tsx";
import Donate from "./pages/Donate.tsx";
import Shirt from "./pages/Shirt.tsx";

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<Intro />} />
				<Route path="/experience/*" element={<Experience />} />
				<Route path="/shirt" element={<Shirt />} />
				<Route path="/donate" element={<Donate />} />
				<Route path="*" element={<NotFound />} />
			</Routes>
		</BrowserRouter>
	</StrictMode>,
);
